module.exports = __webpack_public_path__ + "img/business-man-expanding-futuristic-virtual-screen-modern-tablet.3c069dd0.png";